import React from 'react'
import styled from 'styled-components'
import { colors, media, entranceAnimation } from 'shared/lib'
import { Raffle } from 'shared/types/raffles'
import { RaffleCard } from './RaffleCard'

interface IRaffleGridProps {
  raffles: Raffle[]
  emptyState?: React.ReactNode
}

export const RaffleGrid = ({ raffles, emptyState }: IRaffleGridProps) => {
  return (
    <div>
      {raffles.length === 0 && emptyState}

      {raffles.length > 0 && (
        <CardGrid data-qa="raffle-grid">
          {raffles.map((raffle) => (
            <RaffleCard key={raffle.raffleSlug || raffle.slug} raffle={raffle} />
          ))}
        </CardGrid>
      )}
    </div>
  )
}

// TEMP for first launch, set to display: flex after first raffle
export const FilterRow = styled.div`
  display: none;
  gap: 8px;
  margin-bottom: 0;

  ${media.larger`
    margin-bottom: 80px;
  `}
`

export const FilterPill = styled.button<{ $active: boolean }>`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1;
  padding: 6px 16px;
  height: 32px;
  border-radius: 100px;
  border: 1px solid ${({ $active }) => ($active ? colors.FC2_DARK_GREY : colors.FC2_LIGHTEST_GREY)};
  background-color: ${({ $active }) => ($active ? colors.FC2_BLACK : colors.FC2_OFF_WHITE)};
  color: ${({ $active }) => ($active ? colors.FC2_WHITE : colors.FC2_BLACK)};
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;
`

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 48px 16px;
  padding: 56px 16px 80px;
  align-content: start;
  animation: ${entranceAnimation} 600ms ease-out 400ms backwards;

  ${media.larger`
    padding: 0 40px 80px 0;
    gap: 48px 0;
  `}
`
